import { CHECKOUT_URL } from "~/lib/shopify/constants"

export function getCheckoutUrl(pathname: string): string {
  return `https://${CHECKOUT_URL}${pathname}`
}
